/** All rt timecode math is samples-since-midnight at 48 kHz (BWF TimeReference). */
export const SAMPLE_RATE = 48000

/** Session timecode generator start: 00:59:50:00 (ten seconds of pre-roll before hour one). */
export const TC_START_SAMPLES = (59 * 60 + 50) * SAMPLE_RATE // 172_320_000

function pad2(n: number): string {
  return n < 10 ? `0${n}` : String(n)
}

interface TcParts {
  hh: number
  mm: number
  ss: number
  ff: number
}

function samplesToParts(samples: number, fps: number): TcParts {
  const fpsInt = Math.max(1, Math.round(fps))
  const safe = Math.max(0, samples)
  const totalSec = Math.floor(safe / SAMPLE_RATE)
  const fracSamples = safe - totalSec * SAMPLE_RATE
  const ff = Math.min(fpsInt - 1, Math.floor((fracSamples / SAMPLE_RATE) * fpsInt))
  return {
    hh: Math.floor(totalSec / 3600) % 24,
    mm: Math.floor(totalSec / 60) % 60,
    ss: totalSec % 60,
    ff,
  }
}

/** `HH:MM:SS:FF` for display. */
export function samplesToTc(samples: number, fps: number): string {
  const { hh, mm, ss, ff } = samplesToParts(samples, fps)
  return `${pad2(hh)}:${pad2(mm)}:${pad2(ss)}:${pad2(ff)}`
}

/** 8-digit `HHMMSSFF` used in take file names (e.g. TC01003000). */
export function samplesToTcFileTag(samples: number, fps: number): string {
  const { hh, mm, ss, ff } = samplesToParts(samples, fps)
  return `${pad2(hh)}${pad2(mm)}${pad2(ss)}${pad2(ff)}`
}
